/**
 * Module to add functions that evaluates the Quest object
 */
import {
  ILoyaltyQuestCompletion,
  LoyaltyQuestStatus,
  LoyaltyQuestStepStatus,
} from 'generated/graphql-gateway';

import { IQuest, IQuestStep } from './types';

export const isQuestCompleted = (questStatus: LoyaltyQuestStatus | undefined) =>
  questStatus === LoyaltyQuestStatus.COMPLETED;
export const isQuestActivated = (questStatus: LoyaltyQuestStatus | undefined) =>
  questStatus === LoyaltyQuestStatus.ACTIVATED;
export const canActivateQuest = (questStatus: LoyaltyQuestStatus | undefined) =>
  questStatus === LoyaltyQuestStatus.NOT_ENROLLED;
export const isStepCompleted = (status: LoyaltyQuestStepStatus | undefined) =>
  status === LoyaltyQuestStepStatus.COMPLETED;
export const isIncentiveRedeemed = (lastCompletion: ILoyaltyQuestCompletion | undefined | null) =>
  !!lastCompletion?.redeemed;

export type Tier = {
  bonusPoints: number;
  steps: IQuestStep[];
  status: LoyaltyQuestStepStatus;
};

export const getQuestTiers = (quest: IQuest): Tier[] => {
  const steps = quest?.steps ?? [];
  const questBonusPoints = quest?.bonusPoints ?? 0;

  const tiers: Tier[] = [];
  let currentGroupSteps: IQuestStep[] = [];

  for (let i = 0; i < steps.length; i++) {
    const step = steps[i];
    currentGroupSteps.push(step);

    const hasBonusPoints = (step?.bonusPoints ?? 0) > 0;

    // if the step has bonusPoints, then we close the group
    if (hasBonusPoints) {
      tiers.push({
        bonusPoints: step.bonusPoints ?? 0,
        steps: currentGroupSteps,
        status: step.status,
      });
      currentGroupSteps = [];
      continue;
    }

    const isLastStep = i === steps.length - 1;

    if (isLastStep && currentGroupSteps.length > 0) {
      tiers.push({
        bonusPoints:
          step?.bonusPoints && step.bonusPoints > 0 ? step.bonusPoints : questBonusPoints,
        steps: currentGroupSteps,
        status: step.status,
      });
    }
  }

  return tiers;
};

interface IsTieredChallengeProps {
  quest: IQuest;
  tiers: Tier[];
}
export const isTieredChallenge = ({ quest, tiers }: IsTieredChallengeProps) => {
  const isRegularChallenge = quest?.steps?.every(step => (step?.bonusPoints || 0) > 0);
  const tiersContainsMoreThanOneStep = tiers.some(tier => tier.steps.length > 1);

  return !isRegularChallenge && tiers.length > 1 && tiersContainsMoreThanOneStep;
};
